import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { ReviewClient } from '@frontend/review/api';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useReview:request': CustomEvent<string>;
    }
}

const REQUEST_REVIEW_EVENT = 'useReview:request';
const STORAGE_KEY = 'RVW_REQ';

export function reviewRequest(reviewId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_REVIEW_EVENT, { detail: reviewId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function ReviewResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_REVIEW_EVENT, EntityType.REVIEW, (ids) => ReviewClient.resolveReviews(ids), props.dispatch);
    return <></>;
}
